<template>
	<div class="team">
		<my-header></my-header>
	    
	    <div class="team_main">
	    	<router-view v-wechat-title="$route.meta.title"></router-view>
	    </div>
	    
		<my-footer></my-footer>
	</div>
</template>

<script>
import header from "@/components/common/header";
import footer from "@/components/common/footer";
export default {
  name: "team",
  components: {
    "my-header": header,
    "my-footer": footer
  }
}
</script>

<style scoped lang="scss">
.team{
	min-height: 100vh;
	margin: 0 auto;
	position: relative;
	padding-bottom: 166px;
	.team_main{
		width: 1200px;
		min-height: 500px;
		margin: 0 auto;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/team/index.vue